import { withSentryAssertion } from '@/helpers/withSentryAssertion'
import {
  array,
  CheckerReturnType,
  object,
  optional,
  string,
} from '@recoiljs/refine'

export const BCAddressCustomField = object({
  fieldId: string(),
  fieldValue: string(),
})

export type BCAddressCustomFieldType = CheckerReturnType<typeof BCAddressCustomField>

export const BCAddressCustomFields = array(BCAddressCustomField)

export type BCAddressCustomFieldsType = CheckerReturnType<typeof BCAddressCustomFields>

export const BCAddress = object({
  firstName: optional(string()),
  lastName: optional(string()),
  email: optional(string()),
  company: optional(string()),
  address1: optional(string()),
  address2: optional(string()),
  city: optional(string()),
  stateOrProvince: optional(string()),
  stateOrProvinceCode: optional(string()),
  country: optional(string()),
  countryCode: optional(string()),
  postalCode: optional(string()),
  phone: optional(string()),
  customFields: optional(array(object({
    fieldId: string(),
    fieldValue: string(),
  }))),
})

export type BCAddressType = CheckerReturnType<typeof BCAddress>

export const assertBCAddress = withSentryAssertion([BCAddress, 'Bigcommerce Address'])
